

























import { defineComponent } from '@vue/composition-api';
import {
    SanitizedHtml,
    SdsBrandImage,
} from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    name: 'PendingKyc',
    components: {
        SdsBrandImage,
        SanitizedHtml,
    },
});
